<template>
  <div class="keybox-panel">
    <!-- Header -->
    <div class="mb-2 d-flex align-items-center">
      <feather-icon icon="KeyIcon" size="20" class="text-primary"/>
      <h4 class="mb-0 ml-50">{{ msg('New Keybox') }}</h4>
    </div>

    <!-- Form -->
    <b-card>
      <b-row>

        <!-- Basic Info -->
        <b-col cols="12" md="12">
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group :label="msg('IP Address / Hostname')">
                <b-form-input v-model="keybox.ipAddress" placeholder="192.168.0.10:PORT"/>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group :label="msg('Serial Number')">
                <b-form-input v-model="keybox.serialNumber" placeholder="06e79d9d00720f31"/>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group :label="msg('Device Pass')">
                <b-form-input v-model="keybox.devicePass" placeholder="111111"/>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group :label="msg('Location')">
                <b-form-input v-model="keybox.location" placeholder="e.g. Lobby Entrance"/>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group :label="msg('Status')">
                <b-form-select v-model="keybox.status" :options="statuses"/>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group :label="msg('Installation Status')">
                <b-form-select v-model="keybox.installationStatus" :options="installationStatuses"/>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <hr/>

      <!-- Assignments -->
      <h5 class="mt-2"><i class="fas fa-building text-primary mr-1"></i>{{ msg('Assignments') }}</h5>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group :label="msg('Branch')">
            <v-select
                v-model="keybox.buid"
                :options="allBranches"
                class="w-100"
                label="name"
                :reduce="(branch) => branch.id"
                :clearable="false"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group :label="msg('Building')">
            <building-select-box  v-model="keybox.buildingId"/>
          </b-form-group>
        </b-col>

      </b-row>

      <hr/>

      <!-- Compartments -->
      <h5 class="mt-2"><i class="fas fa-box text-primary mr-1"></i>{{ msg('Slots') }}</h5>
      <b-row v-if="keybox.buildingId!=null">
        <b-col cols="3" md="3">
          <b-form-group :label="msg('Total Slots')">
            <b-form-select
                v-model.number="keybox.totalCompartments"
                :options="[
        { value: 12, text: '12' },
        { value: 24, text: '24' },
        { value: 36, text: '36' }
      ]"
                @change="generateCompartments"
            />
          </b-form-group>
        </b-col>

      </b-row>

      <b-row v-if="compartments.length">
        <b-col
            cols="12" md="12"
            v-for="comp in compartments"
            :key="comp.number"
        >
          <b-card class="">
            <div class="d-flex justify-content-between align-items-center">
              <strong>{{ msg('Slot') }} #{{ comp.number }}</strong>
            </div>
            <b-form-group :label="msg('Assigned Room')">
              <real-estate-picker-locker :buildings="[keybox.buildingId]" v-model="comp.realEstateId"/>
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <!-- Save -->
    <div class="text-right mt-2">
      <b-button variant="outline-primary" class="px-3" @click="createKeybox">
        <feather-icon icon="SaveIcon" size="16" class="mr-50"/>
        {{ msg('Save') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import RealEstatePickerLocker from "@/components/components/picker/realEstatesPickerLocker.vue";
import BuildingSelectBox from "@/components/components/picker/buildingSelectBox.vue";

export default {
  name: 'KeyboxPanel',
  components: {BuildingSelectBox, RealEstatePickerLocker},
  data() {
    return {
      keybox: {
        totalCompartments: 0
      },
      compartments: [],
      statuses: [
        { value: 'online', text: 'Online' },
        { value: 'offline', text: 'Offline' },
        { value: 'error', text: 'Error' }
      ],
      installationStatuses: [
        { value: 'installed', text: 'Installed' },
        { value: 'pending', text: 'Pending' },
        { value: 'failed', text: 'Failed' }
      ]
    }
  },
  computed: {
    ...mapGetters('data', ['getAllBranches']),
    allBranches() {
      return Object.values(this.getAllBranches)
    }
  },
  methods: {
    ...mapActions('keybox', ['addKeybox']),
    msg(str) { return str }, // replace with your i18n system
    generateCompartments() {
      if (this.keybox.totalCompartments > 50) {
        this.$bvToast.toast(this.msg('Maximum 50 compartments allowed'), {
          title: this.msg('Error'),
          variant: 'danger',
          solid: true
        })
        this.keybox.totalCompartments = 50
      }

      const newCompartments = []

      // Keep existing choices when possible
      for (let i = 1; i <= this.keybox.totalCompartments; i++) {
        const existing = this.compartments.find(c => c.number === i)
        if (existing) {
          newCompartments.push(existing) // keep assigned realEstateId, accessCode etc
        } else {
          newCompartments.push({
            number: i,
            realEstateId: null,
            isOpen: false,
            accessCode: null
          })
        }
      }

      this.compartments = newCompartments
      this.keybox.compartments = this.compartments
    }

    ,
    createKeybox() {
      this.keybox.compartments = this.compartments
      this.addKeybox({ keybox: this.keybox })
          .then(id => this.$emit('submitted', {status: true, server: id, id}))
          .catch(err => this.$emit('submitted', {status: false, server: err}))
    }
  }
}
</script>

<style scoped>
.keybox-panel {
  padding: 10px;
}
h5 {
  font-weight: 600;
  margin-bottom: 10px;
}
</style>
